import { QueryObserverOptions, useQuery } from 'react-query';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { getAction } from './api';
import { QueryKey } from '../QueryKey';
import { goToErrorPage } from 'utils';
import { ActionDTO } from './dto/ActionDTO';

type UseQueryOptionsKeys = QueryObserverOptions<ActionDTO>;

export default function useAction(actionId: number, options?: UseQueryOptionsKeys) {
  const { t } = useTranslation();
  const { data: action, isLoading } = useQuery<ActionDTO>(
    [QueryKey.ACTION, actionId],
    () => getAction(actionId),
    {
      onError: (error: any) => {
        goToErrorPage(error);
        toast.error(t('message.title.error.get.action'));
      },
      retry: false,
      ...options,
    }
  );

  return { action, isLoading };
}
